import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useTranslation } from '../../i18n'
import { useConnectionStore } from '../../../store/connection'
import { askConfirm } from '../../../helpers/dialogs'
import { openCluster } from '../../../helpers/router'
import { genColumns } from '../../../helpers/tableColumns'

export const useClusterTable = () => {
  const t = useTranslation()
  const connectionStore = useConnectionStore()
  const router = useRouter()

  const filter = ref('')
  const clusters = computed(() => {
    const search = filter.value.toLowerCase().trim()

    return [...connectionStore.clusters]
      .map((cluster, i) => Object.assign({}, cluster, { index: i }))
      .filter((cluster) => {
        return (
          cluster.name.toLowerCase().includes(search) ||
          cluster.uri.toLowerCase().includes(search) ||
          cluster.clusterName.toLowerCase().includes(search)
        )
      })
  })

  const removeInstance = async (id: string) => {
    const cluster = connectionStore.clusterById(id)
    if (!cluster) return
    const confirmed = await askConfirm(
      t('cluster_selection.cluster_table.row.remove_cluster.confirm', { name: cluster.name, uri: cluster.uri })
    )
    if (!confirmed) return

    connectionStore.removeCluster(id)
    if (id === connectionStore.activeClusterId) router.push('/')
  }

  const loadCluster = (id: string) => openCluster(router, id)
  const columns = genColumns([
    { label: t('cluster_selection.cluster_table.headers.cluster'), field: 'name' },
    { label: t('cluster_selection.cluster_table.headers.uri') },
    { label: t('cluster_selection.cluster_table.headers.version'), field: 'version' },
    { label: '' }
  ])

  return {
    filter,
    clusters,
    removeInstance,
    loadCluster,
    columns
  }
}
